/**
 * @name vegas sidebar
 * @copyright by vegas s.
 * @date: 27.10.2018
 * @version  1.0
 *
 */

window.VegasSidebar = {
	body: $('body'),

	open: function (self) {
		var $self = $(self),
			target = $self.data('target') || $self.attr('href');

		var $container = $(target);

		var width_scrollbar = window.innerWidth - document.documentElement.clientWidth;

		if ($self.data('load')) {
			var route = $self.data('load');
			var params = $self.data('params') || {};
			$.get(route, params, function (data) {
				if (data.view) {
					$container.find('.content').html(data.view);
				}
			});
		}

		$container.addClass('show');
		this.body.addClass('sidebar-open').css('padding-right', width_scrollbar);

		return false;
	},
	close: function (self) {
		var $self = $(self);
		var $container = $self.closest('.vg-sidebar');

		$container.removeClass('show');
		this.body.removeClass('sidebar-open').removeAttr('style');
	}
};

// sidebars
$(document).on('click', '[data-toggle=sidebar-open]', function () {
	VegasSidebar.open(this);

	return false;
});

$(document).on('click', '[data-toggle=sidebar-close], .vg-sidebar', function (e) {
	if (e.target !== this) return;

	VegasSidebar.close(this);

	return false;
});
